import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from '../ui/sidebar';
import { useContext } from 'react';
import { UserContext } from '../../context/userContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { MdOutlineSupportAgent, MdOutlineAccountCircle } from 'react-icons/md';
import { IoStatsChart, IoLogOutOutline } from 'react-icons/io5';
import { FiMoreVertical } from 'react-icons/fi';

export function NavUser() {
    const { isMobile } = useSidebar();
    const { logout, user } = useContext(UserContext);
    const navigate = useNavigate();

    const avatar = '/mascot1.png';

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <div>
                            <SidebarMenuButton
                                size="lg"
                                className="data-[state=open]:tw-bg-sidebar-accent data-[state=open]:tw-text-sidebar-accent-foreground"
                            >
                                <Avatar className="tw-h-8 tw-w-8 tw-rounded-lg">
                                    <AvatarImage src={avatar} alt={user?.username} />
                                    <AvatarFallback className="tw-rounded-lg">LH</AvatarFallback>
                                </Avatar>
                                <div className="tw-grid tw-flex-1 tw-text-left tw-text-sm tw-leading-tight">
                                    <span className="tw-truncate tw-font-medium">
                                        {user?.username}
                                    </span>
                                    <span className="tw-truncate tw-text-xs tw-text-muted-foreground">
                                        {user?.email ? user.email : user?.client}
                                    </span>
                                </div>
                                <FiMoreVertical className="tw-ml-auto tw-size-4" />
                            </SidebarMenuButton>
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="tw-w-[var(--radix-dropdown-menu-trigger-width)] tw-min-w-56 tw-rounded-lg"
                        side={isMobile ? 'bottom' : 'right'}
                        align="end"
                        sideOffset={4}
                    >
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <img
                                        className="tw-mx-[-4px] tw-mb-2 tw-mt-[-4px] tw-w-[calc(100%+8px)] tw-rounded-t-lg tw-object-cover"
                                        src={avatar}
                                        alt="mascot"
                                    />
                                </TooltipTrigger>
                                <TooltipContent>
                                    <h3 className="tw-m-0 tw-my-1 tw-p-0">Meet Fluffy Tenant 🏖️</h3>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                        <DropdownMenuLabel className="tw-p-0 tw-font-normal">
                            <div className="tw-flex tw-items-center tw-gap-2 tw-px-1 tw-py-1.5 tw-text-left tw-text-sm">
                                <Avatar className="tw-h-8 tw-w-8 tw-rounded-lg">
                                    <AvatarImage src={avatar} alt={user?.username} />
                                    <AvatarFallback className="tw-rounded-lg">LH</AvatarFallback>
                                </Avatar>
                                <div className="tw-grid tw-flex-1 tw-text-left tw-text-sm tw-leading-tight">
                                    <span className="tw-truncate tw-font-medium">
                                        {user?.username}
                                    </span>
                                    <span className="tw-truncate tw-text-xs tw-text-muted-foreground">
                                        {user?.email ? user.email : user?.client}
                                    </span>
                                </div>
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuGroup>
                            <DropdownMenuItem onClick={() => navigate('/settings#account')}>
                                <MdOutlineAccountCircle />
                                Account
                            </DropdownMenuItem>
                            {user?.userType === 'landlord' ||
                            user?.userType === 'accountant' ? null : (
                                <>
                                    <DropdownMenuItem onClick={() => navigate('/insights')}>
                                        <IoStatsChart />
                                        Insights
                                    </DropdownMenuItem>
                                    <DropdownMenuItem onClick={() => navigate('/support')}>
                                        <MdOutlineSupportAgent />
                                        Support
                                    </DropdownMenuItem>
                                </>
                            )}
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={logout}>
                            <IoLogOutOutline />
                            Log out
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    );
}
